<template>
  <section class="position-relative"
           :class="textClass">
    <div class="progress position-absolute w-100 top-50 start-50 translate-middle z-behind"
         :style="heightValue">
      <div :class="progressBarClass"
           :aria-valuenow="value" aria-valuemin="0" aria-valuemax="100"
           :style="widthValue"></div>
    </div>
    <span class="mx-1" :class="labelClass">
      <template v-if="valueVisible">{{value}}</template>
      <template v-if="valueVisible && unitVisible">{{unit}}</template>
    </span>
  </section>
</template>

<script>
  import { defineComponent } from "vue";

  export default defineComponent({
    props: {
      value: {
        type: Number,
        default: 0,
      },
      unit: {
        type: String,
        default: "%",
      },
      min: {
        type: Number,
        default: 0,
      },
      max: {
        type: Number,
        default: 100,
      },
      valueVisible: {
        type: Boolean,
        default: true,
      },
      unitVisible: {
        type: Boolean,
        default: true,
      },
      labelPosition: {
        type: String,
        default: "center",
        validator: (val) => {
          return ["start", "center", "end",].includes(val); 
        },
      },
      textBorderTheme: {
        type: String,
        default: "light",
        validator: (val) => {
          return ["none", "primary", "secondary", "success", "info", "warning", "danger", "light", "dark", ].includes(val);
        }
      },
      progressBarTheme: {
        type: String,
        default: "none",
        validator: (val) => {
          return ["none", "primary", "secondary", "success", "info", "warning", "danger", "light", "dark",].includes(val);
        }
      },
      size: {
        type: Number,
        default: 1,
        validator: (val) => {
          return 0 <= val && val < 10;
        },
      },
    },
    computed: {
      labelClass: function () {
        if (this.textBorderTheme == "none") return "";
        return `text-border-${this.textBorderTheme}`;
      },
      textClass: function() {
        return `text-${this.labelPosition}`;
      },
      progressBarClass: function () {
        if (this.progressBarTheme == "none") return "progress-bar";
        return `progress-bar bg-${this.progressBarTheme}`;
      },
      heightValue: function () {
        if (this.size == 0) return "height: 100%;";
        return `height: ${this.size}rem;`;
      },
      widthValue: function () {
        return `width: ${Math.round(((this.value - this.min) / (this.max - this.min) * 1000) / 10)}%;`
      },
    }
  });

</script>
